import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { ToastService } from '../../../core/services/toast.service';

@Component({
  selector: 'rps-toast-host',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: [`
    .rps-toast-host {
      position: fixed;
      bottom: 1.5rem;
      right: 1.5rem;
      z-index: 9999;
      display: flex;
      flex-direction: column;
      gap: .6rem;
      pointer-events: none;
    }
    .rps-toast {
      display: flex;
      align-items: center;
      gap: .6rem;
      padding: .7rem 1rem;
      border-radius: 8px;
      font-size: 13.5px;
      font-weight: 500;
      box-shadow: 0 4px 16px rgba(0,0,0,.12);
      pointer-events: auto;
      min-width: 260px;
      max-width: 380px;
      animation: toastIn .18s ease;
    }
    @keyframes toastIn { from { opacity:0; transform:translateY(8px); } to { opacity:1; transform:translateY(0); } }
    .rps-toast--success { background:#f0fdf4; color:#166534; border-left:3px solid #22c55e; }
    .rps-toast--danger  { background:#fef2f2; color:#991b1b; border-left:3px solid #ef4444; }
    .rps-toast--warning { background:#fffbeb; color:#92400e; border-left:3px solid #f59e0b; }
    .rps-toast__close { margin-left:auto; background:none; border:none; cursor:pointer; font-size:14px; opacity:.6; color:inherit; padding:0 2px; }
    .rps-toast__close:hover { opacity:1; }
  `],
  template: `
    <div class="rps-toast-host" aria-live="polite" aria-atomic="false">
      @for (t of svc.toasts(); track t.id) {
        <div [class]="'rps-toast rps-toast--' + t.type" role="alert">
          <i [class]="iconFor(t.type)"></i>
          <span>{{ t.message }}</span>
          <button class="rps-toast__close" (click)="svc.dismiss(t.id)" aria-label="Dismiss">✕</button>
        </div>
      }
    </div>
  `
})
export class RpsToastHostComponent {
  svc = inject(ToastService);

  iconFor(type: string): string {
    const icons: Record<string, string> = {
      success: 'fas fa-circle-check',
      danger:  'fas fa-circle-xmark',
      warning: 'fas fa-triangle-exclamation',
    };
    return icons[type] ?? 'fas fa-bell';
  }
}
